import React, { useEffect } from 'react'
import { useModal } from './useModal'
import { errorEmitter } from '../services/axios-instance'
import ErrorModal from '../components/modals/error-modal/error-modal'

export const useErrorHandler = () => {
	const { showErrorModal, clearModal } = useModal()

	useEffect(() => {
		const handleError = (event) => {
			const { message } = event.detail
			showErrorModal(
				<ErrorModal description={message} />
			)
			// Limpiar cualquier modal normal después de un pequeño delay
			setTimeout(() => {
				clearModal()
			}, 10)
		}

		errorEmitter.addEventListener('apiError', handleError)
		return () => errorEmitter.removeEventListener('apiError', handleError)
	}, [showErrorModal, clearModal])
}